export const SEO_LANDING_PAGES = {
  'terrain-a-vendre-guinee': {
    title: 'Terrain à vendre en Guinée',
    metaTitle: 'Terrain à vendre en Guinée | Démarcheur',
    description: 'Trouvez des terrains à vendre en Guinée : Conakry, Kindia, Dubréka, Coyah, Kankan, Labé, Boké et les autres villes.',
    kicker: 'Terrains en Guinée',
    hero: 'Acheter un terrain en Guinée avec les bons réflexes',
    intro: 'Comparez les parcelles disponibles, contactez directement les propriétaires ou agences, puis vérifiez les documents avant tout paiement.',
    searchLink: '/?type=terrain',
    ctaLabel: 'Voir les terrains',
    bullets: [
      'Demandez le plan, les limites et les documents du terrain.',
      'Vérifiez l’emplacement avec une visite physique ou une personne de confiance.',
      'Comparez les prix par zone avant de vous engager.',
    ],
    sections: [
      ['Où chercher ?', 'Les zones les plus demandées restent Conakry, Dubréka, Coyah, Kindia et les villes avec forte croissance. Utilisez les filtres pour comparer par ville, quartier et surface.'],
      ['Avant d’acheter', 'Ne vous limitez pas aux photos. Demandez les documents, l’identité du vendeur et une confirmation locale de l’emplacement.'],
    ],
  },
  'maison-a-vendre-guinee': {
    title: 'Maison à vendre en Guinée',
    metaTitle: 'Maison à vendre en Guinée | Démarcheur',
    description: 'Maisons, villas et duplex à vendre en Guinée. Trouvez un bien à Conakry et dans les principales villes guinéennes.',
    kicker: 'Achat maison',
    hero: 'Trouver une maison à vendre en Guinée',
    intro: 'Démarcheur vous aide à consulter les maisons, villas et duplex disponibles, avec contact direct propriétaire ou agence.',
    searchLink: '/?type=vente-maison',
    ctaLabel: 'Voir les maisons',
    bullets: [
      'Comparez les quartiers, surfaces, chambres et prix.',
      'Demandez une visite vidéo si vous êtes à l’étranger.',
      'Confirmez les documents et l’état réel du bien.',
    ],
    sections: [
      ['Pour vivre ou investir', 'Une maison en Guinée peut servir de résidence familiale, de projet de retour ou d’investissement locatif. Commencez par votre budget et votre ville cible.'],
      ['Contact direct', 'Chaque annonce permet de contacter l’annonceur par WhatsApp, téléphone ou message afin d’avancer rapidement.'],
    ],
  },
  'location-maison-conakry': {
    title: 'Location maison à Conakry',
    metaTitle: 'Location maison à Conakry | Démarcheur',
    description: 'Locations de maisons, appartements et villas à Conakry. Recherchez par quartier, budget et période de location.',
    kicker: 'Location Conakry',
    hero: 'Louer une maison ou un appartement à Conakry',
    intro: 'Trouvez une location adaptée à votre séjour, votre installation ou votre famille, avec des annonces classées par ville et quartier.',
    searchLink: '/?type=location&ville=Conakry',
    ctaLabel: 'Voir les locations',
    bullets: [
      'Filtrez par ville, quartier, prix et période.',
      'Confirmez la caution, les charges et la disponibilité.',
      'Organisez une visite avant tout versement.',
    ],
    sections: [
      ['Quartiers recherchés', 'Kipé, Nongo, Lambanyi, Hamdallaye, Ratoma et Bambeto font partie des zones souvent consultées selon les besoins.'],
      ['Location au mois', 'Pour une installation durable, vérifiez la durée du contrat, les charges, la caution et les conditions de sortie.'],
    ],
  },
  'location-courte-duree-conakry': {
    title: 'Location courte durée à Conakry',
    metaTitle: 'Location courte durée à Conakry | Démarcheur',
    description: 'Locations par jour ou par semaine à Conakry pour vacances, missions, événements, retour au pays ou séjour familial.',
    kicker: 'Court séjour',
    hero: 'Trouver une location par jour ou par semaine à Conakry',
    intro: 'Préparez un court séjour en Guinée avec des locations adaptées aux voyages, missions, vacances et retours familiaux.',
    searchLink: '/?type=location&ville=Conakry&periodeLocation=jour',
    ctaLabel: 'Voir les courts séjours',
    bullets: [
      'Cherchez les locations par jour, semaine ou mois.',
      'Demandez les équipements inclus et les conditions d’entrée.',
      'Confirmez l’adresse exacte avant votre arrivée.',
    ],
    sections: [
      ['Pour la diaspora', 'Cette recherche est utile si vous venez quelques jours ou semaines en Guinée et souhaitez préparer votre logement avant le départ.'],
      ['Sécurité', 'Évitez les acomptes précipités. Demandez photos récentes, vidéo du logement et confirmation écrite des conditions.'],
    ],
  },
  'acheter-en-guinee-depuis-france': {
    title: 'Acheter en Guinée depuis la France',
    metaTitle: 'Acheter un bien en Guinée depuis la France | Démarcheur',
    description: 'Guide pour la diaspora en France : trouver une maison, un terrain ou une location en Guinée avec contact direct et vérifications.',
    kicker: 'Diaspora France',
    hero: 'Préparer un achat immobilier en Guinée depuis la France',
    intro: 'Consultez les annonces, publiez votre besoin et échangez avec les propriétaires ou agences avant de faire vérifier le bien sur place.',
    searchLink: '/diaspora',
    ctaLabel: 'Guide diaspora',
    bullets: [
      'Publiez votre besoin si vous cherchez un bien précis.',
      'Demandez une visite vidéo et des documents lisibles.',
      'Faites contrôler le bien par une personne de confiance en Guinée.',
    ],
    sections: [
      ['Acheter à distance', 'L’achat depuis l’étranger demande plus de méthode : documents, identité du vendeur, localisation exacte et preuve de propriété doivent être vérifiés.'],
      ['Démarcheur comme point de départ', 'La plateforme facilite la recherche et le contact direct. Elle ne remplace pas les vérifications juridiques ou administratives avant paiement.'],
    ],
  },
};

export const SEO_LANDING_LINKS = Object.entries(SEO_LANDING_PAGES).map(([slug, page]) => ({
  slug,
  title: page.title,
  href: `/guide/${slug}`,
}));
